import { render, staticRenderFns } from "./huoche.vue?vue&type=template&id=0c089d62&"
import script from "./huoche.vue?vue&type=script&lang=js&"
export * from "./huoche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports